import { useCallback, useState } from 'react';
import { AJAX_URL } from '../../config/index.js';
import axios from 'axios';

const useCutInfoHandler = (cutId) => {
  const [cutInfo, setCutInfo] = useState({});
  const [cutInfoError, setCutInfoError] = useState("");
  const [detailModal, setDetailModal] = useState(false);

  const cardClickHandler = useCallback((cutId) => {
    const url = `${AJAX_URL}post_wlQueryCutInfo`;
    const payload = new FormData();
    payload.append('cutId', cutId);

    axios
      .post(url, payload)
      .then((res) => {
        setCutInfo(res.data.data);
        setDetailModal(true);
      })
      .catch((err) => setCutInfoError(err.message));
  });

  const closeModalHandler = useCallback(() => setDetailModal(false));

  return [
    cutInfo,
    cutInfoError,
    detailModal,
    cardClickHandler,
    closeModalHandler
  ];
};

export default useCutInfoHandler;
